/** Remove acentos e caracteres especiais, converte para lowercase com hifens. */
export function slugify(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** DB value -> URL segment */
export const TIPO_URL: Record<string, string> = {
  'apartamento':           'apartamentos',
  'casa':                  'casas',
  'sobrado':               'sobrados',
  'cobertura':             'coberturas',
  'kitnet':                'kitnets',
  'quitinete':             'quitinetes',
  'studio':                'studios',
  'flat':                  'flats',
  'casa em condomínio':    'casas-em-condominio',
  'sobrado em condomínio': 'sobrados-em-condominio',
  'lote em condomínio':    'lotes-em-condominio',
  'terreno':               'terrenos',
  'lote':                  'lotes',
  'chácara':               'chacaras',
  'fazenda':               'fazendas',
  'vila':                  'vilas',
  'sala':                  'salas-comerciais',
  'loja':                  'lojas',
  'galpão':                'galpoes',
  'prédio':                'predios',
  'consultório':           'consultorios',
  'hotel':                 'hoteis',
  'garagem':               'garagens',
};

/** DB value -> URL segment */
export const FINALIDADE_URL: Record<string, string> = {
  'venda':   'venda',
  'aluguel': 'aluguel',
};

/** URL segment -> DB value */
export const URL_TO_TIPO: Record<string, string> = Object.fromEntries(
  Object.entries(TIPO_URL).map(([k, v]) => [v, k])
);

/** URL segment -> DB value */
export const URL_TO_FINALIDADE: Record<string, string> = Object.fromEntries(
  Object.entries(FINALIDADE_URL).map(([k, v]) => [v, k])
);

/** URL segment -> label de exibicao */
export const TIPO_LABEL: Record<string, string> = {
  'apartamentos':           'Apartamentos',
  'casas':                  'Casas',
  'sobrados':               'Sobrados',
  'coberturas':             'Coberturas',
  'kitnets':                'Kitnets',
  'quitinetes':             'Quitinetes',
  'studios':                'Studios',
  'flats':                  'Flats',
  'casas-em-condominio':    'Casas em Condomínio',
  'sobrados-em-condominio': 'Sobrados em Condomínio',
  'lotes-em-condominio':    'Lotes em Condomínio',
  'terrenos':               'Terrenos',
  'lotes':                  'Lotes',
  'chacaras':               'Chácaras',
  'fazendas':               'Fazendas',
  'vilas':                  'Vilas',
  'salas-comerciais':       'Salas Comerciais',
  'lojas':                  'Lojas',
  'galpoes':                'Galpões',
  'predios':                'Prédios',
  'consultorios':           'Consultórios',
  'hoteis':                 'Hotéis',
  'garagens':               'Garagens',
};

/** URL segment -> label de exibicao */
export const FINALIDADE_LABEL: Record<string, string> = {
  'venda':   'à Venda',
  'aluguel': 'para Alugar',
};

/**
 * Monta a URL de uma pagina de listagem.
 * Todos os parametros devem ser URL slugs ja prontos (sem acentos, lowercase).
 *
 * @example
 * buildListingUrl({ finalidade: 'venda', tipo: 'apartamentos', bairro: 'setor-bueno' })
 * // -> '/imoveis/venda/apartamentos/setor-bueno/'
 */
export function buildListingUrl(params: {
  finalidade: string;
  tipo?: string;
  bairro?: string;
}): string {
  const parts = ['/imoveis', params.finalidade];
  if (params.tipo)   parts.push(params.tipo);
  if (params.bairro) parts.push(params.bairro);
  return parts.join('/') + '/';
}

/**
 * Converte um nome de bairro do banco para um URL slug.
 */
export function bairroToSlug(bairro: string): string {
  return slugify(bairro);
}
